import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'

import { ParcelFilter } from '@/webApi/DataModels'
import moment from 'moment'
import { isNumber } from 'lodash'
import { getLastWorkingDay } from '@/helper'

function createArrayFromRouteParam (param: any): number[] {
  var result: number[] = []
  if (param === null || param === undefined || param === '-1' || param === -1) {
    result = []
  } else if (isNumber(param)) {
    result = [param]
  } else {
    result = param.split(',').map(Number)
  }
  return result
}

class ParcelFilterState {
  public currentReportFilter: ParcelFilter = null
  public currentExportProofFilter: ParcelFilter = null
  public currentDropCostFilter: ParcelFilter = null
  public currentParcelFilter: ParcelFilter = null
  public currentDashboardFilter: ParcelFilter = null
}
const mutations = <MutationTree<ParcelFilterState>>{
  setParcelFilter (state: ParcelFilterState, { parcelFilter, filterName }: { parcelFilter: ParcelFilter, filterName: string }) {
    var clonedFilter = Object.assign({}, parcelFilter)
    // Clone the incomming filter to ensure that editing does not fire watchers on current filters
    switch (filterName) {
      case 'dashboard':
        state.currentDashboardFilter = clonedFilter
        break

      case 'report':
        state.currentReportFilter = clonedFilter
        break

      case 'exportProof':
        state.currentExportProofFilter = clonedFilter
        break

      case 'drop-cost':
        state.currentDropCostFilter = clonedFilter
        break

      case 'parcel':
      default:
        state.currentParcelFilter = clonedFilter
        break
    }
  },
  reset (state:ParcelFilterState) {
    state.currentDashboardFilter = null
    state.currentParcelFilter = null
    state.currentReportFilter = null
    state.currentExportProofFilter = null
    state.currentDropCostFilter = null
  }
}
const actions = <ActionTree<ParcelFilterState, any>>{
  reset (store: ActionContext<ParcelFilterState, any>):void {
    store.commit('reset')
  },
  setParcelFilterFromRoute (store: ActionContext<ParcelFilterState, any>, { routeFilter, filterName }: { routeFilter: any, filterName: string }): void {
    var countryIDs: number[] = createArrayFromRouteParam(routeFilter.country_id)
    var currentEventInfos: number[] = createArrayFromRouteParam(routeFilter.current_event_infos)
    var customerIDs: number[] = createArrayFromRouteParam(routeFilter.customer_id)
    var providerIDs: number[] = createArrayFromRouteParam(routeFilter.providers)
    var tagIDs: number[] = createArrayFromRouteParam(routeFilter.tags)
    var parcelStatus: number[] = createArrayFromRouteParam(routeFilter.status)
    var serviceLevelIDs: number[] = createArrayFromRouteParam(routeFilter.service_level_id)

    var fromPostalCode: string = routeFilter.from_postal_code
    if (fromPostalCode === '-1') {
      fromPostalCode = ''
    }

    var toPostalCode: string = routeFilter.to_postal_code
    if (toPostalCode === '-1') {
      toPostalCode = ''
    }
    var forwardFlow: boolean = routeFilter.show_forward_flow
    if (routeFilter.show_forward_flow === true || routeFilter.show_forward_flow === 'true') {
      forwardFlow = true
    } else {
      forwardFlow = false
    }

    var filter: ParcelFilter = {
      Countries: countryIDs,
      Current_Event_Infos: currentEventInfos,
      Customers: customerIDs,
      Providers: providerIDs,
      Tags: tagIDs,
      From_Date: routeFilter.from_date,
      To_Date: routeFilter.to_date,
      Parcel_Status: parcelStatus,
      Service_Levels: serviceLevelIDs,
      Show_Forward_Flow: forwardFlow,
      From_Postal_Code: fromPostalCode,
      To_Postal_Code: toPostalCode
    }
    store.commit('setParcelFilter', { parcelFilter: filter, filterName: filterName })
  },
  initRootState (store: ActionContext<ParcelFilterState, any>, routeFilter: any): Promise<any> {
    let fromDate = moment()
    if (store.rootState.personalSettings.personalSettings.Default_Date === -1) {
      fromDate = getLastWorkingDay()
    }
    createDefaultFilters(store, fromDate)
    return Promise.resolve()
  }
}

const getters = <GetterTree<ParcelFilterState, any>>{
  parcelFilter: (state: ParcelFilterState) => {
    return (filterName: string): ParcelFilter => {
      switch (filterName) {
        case 'dashboard':
          return Object.assign({}, state.currentDashboardFilter)

        case 'report':
          return Object.assign({}, state.currentReportFilter)

        case 'exportProof':
          return Object.assign({}, state.currentExportProofFilter)

        case 'drop-cost':
          return Object.assign({}, state.currentDropCostFilter)

        case 'parcel':
        default:
          return Object.assign({}, state.currentParcelFilter)
      }
    }
  }
}

function createDefaultFilters (store: ActionContext<ParcelFilterState, any>, fromDate:any) {
  var defaultFilter:ParcelFilter = {
    Countries: store.rootState.personalSettings.personalSettings.Default_Countries,
    Current_Event_Infos: store.rootState.personalSettings.personalSettings.Default_Events,
    Customers: store.rootState.personalSettings.personalSettings.Default_Customers,
    Providers: store.rootState.personalSettings.personalSettings.Default_Providers,
    Tags: store.rootState.personalSettings.personalSettings.Default_Tags,
    From_Date: fromDate.format(),
    To_Date: moment().add(store.rootState.personalSettings.personalSettings.Default_Date, 'days').format(),
    Parcel_Status: store.rootState.personalSettings.personalSettings.Default_Parcel_Status,
    Service_Levels: store.rootState.personalSettings.personalSettings.Default_Service_Levels,
    Show_Forward_Flow: store.rootState.personalSettings.personalSettings.Default_Flow === 'Forward',
    From_Postal_Code: store.rootState.personalSettings.personalSettings.Default_Postal_Code_From,
    To_Postal_Code: store.rootState.personalSettings.personalSettings.Default_Postal_Code_To
  }
  store.commit('setParcelFilter', { parcelFilter: Object.assign({}, defaultFilter), filterName: 'dashboard' })
  store.commit('setParcelFilter', { parcelFilter: Object.assign({}, defaultFilter), filterName: 'drop-cost' })
  store.commit('setParcelFilter', { parcelFilter: Object.assign({}, defaultFilter), filterName: 'parcel' })
}

export default ({
  namespaced: true,
  state: new ParcelFilterState(),
  mutations,
  actions,
  getters
})
